export const getActionColumn = (handleClickEdit, handleClickDelete) => [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => (
        <div className="cellAction">
          <div className="viewButton" onClick={() => handleClickEdit(params.row.id)}>Editar</div>
          <div className="deleteButton" onClick={() => handleClickDelete(params.row.id)}>Eliminar</div>
        </div>
      ),
    },
  ];
  